import imageFragment from 'js/graphqlFragments/ImageFragment';

const fetchData = (pageId: number): string => `
    {
    post(id: "${pageId}", idType: DATABASE_ID) {
      title
      SelfLearning {
        titleSelfLearning
        descriptionSelfLearning
        mainTabs {
          firstItem {
            fieldGroupName
            title
            shortDescription
            successMessage
            completePopup
            confirmCompletion
            icon {
              ...ImageFragmentIcon
            }
          }
          secondItem {
            fieldGroupName
            title
            shortDescription
            successMessage
            completePopup
            confirmCompletion
            icon {
              ...ImageFragmentIcon
            }
          }
        }
        firstTabData {
          description
          filterTabs {
            tabTitle
            ufid
            faq {
              ufid
              caseHeader
              caseBody
            }
          }
        }
        secondTabData {
          description
          filterTabs {
            tabTitle
            ufid
            faq {
              ufid
              caseHeader
              caseBody
            }
          }
        }
      }
    }
    selfLearning {
        getStatusById(post_id: "${pageId}") {
          faq_id
          status
        }
      }
     monday {
        Monday {
          feedback {
            articleFeedbackTitle
          }
        }
      }
  }
  ${imageFragment('Icon')}
`;
export default fetchData;
